import { useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import {
  DropdownContent,
  DropdownGroup,
  dropDownStore,
  DropdownTextInput,
  Scrollbar,
  SpinnerLoader,
} from 'shared/ui'
import { type IHubspotPropertiesObjectType } from 'entities/Integrations'
import { useNewPropertiesDropdownContext } from 'widgets/NewPropertiesDropdown/context/newPropertiesDropdownContext'
import styles from './styles.module.scss'

type INewHubspotPropertiesDropdownContentProps = {
  dropdownId: string
  objectType?: IHubspotPropertiesObjectType
  objectId?: number
}

export const NewPropertiesDropdownContent: FC<INewHubspotPropertiesDropdownContentProps> = observer(
  ({ dropdownId, objectType, objectId }) => {
    const store = useNewPropertiesDropdownContext()

    useEffect(() => {
      store.setDropdownId(dropdownId)
      store.searchFields('', true, objectType, objectId)
    }, [])

    return (
      <DropdownContent noPadding>
        <DropdownTextInput
          textFieldProps={{
            value: store.search,
            onChange: (term) => store.searchFields(term, false, objectType, objectId),
            InputProps: {
              placeholder: 'Search',
            },
          }}
        />
        {store.loading && (
          <div className={styles.loader}>
            <SpinnerLoader ariaLabel={'NewPropertiesDropdownContent'} size={20} />
          </div>
        )}

        {!store.loading && !!store.properties.length && (
          <Scrollbar
            autoHeight
            autoHeightMin={0}
            autoHeightMax={178}
            onScroll={() => {
              dropDownStore.allHide(dropdownId)
            }}
          >
            <DropdownGroup
              items={store.properties}
              onChange={(item) => {
                store.addToSelectedFields(item.id)
              }}
              isScroll={false}
            />
          </Scrollbar>
        )}

        {!store.loading && !store.properties.length && (
          <div className={styles.noResult}>No results found</div>
        )}
      </DropdownContent>
    )
  }
)
